export const recommendations = [
  {
    id: 'star-traveler',
    title: '星屑彼端的旅人',
    tagline: '一人一灯，横穿星海沙漠',
    genres: ['奇幻', '冒险'],
    tags: ['公路冒险', '群像', '世界观庞大'],
    season: '本季新番',
    score: 9.1,
    episodes: '全 12 话 · 更新至 08',
    air: '每周四 22:30 更新',
    desc: '失去故乡的少年带着一盏不会熄灭的提灯，在星屑不断坠落的沙漠里寻找传说中的终点站。旅途中他将遇见各怀心事的同行者，也在一次次离别里重新理解“归途”的含义。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20illustration%20of%20a%20lone%20traveler%20with%20a%20glowing%20lantern%20walking%20across%20a%20starlit%20desert%20under%20a%20vast%20starry%20sky%2C%20warm%20amber%20and%20deep%20teal%20color%20palette%2C%20stylized%20digital%20painting%2C%20dramatic%20lighting%2C%20energetic%20composition%2C%20no%20text&width=600&height=800&seq=yaojing-cover-star-01&orientation=portrait',
  },
  {
    id: 'mecha-spring',
    title: '机械心脏与春日约定',
    tagline: '少女工程师与她的第一台机器',
    genres: ['科幻', '治愈'],
    tags: ['机械', '日常', '成长'],
    season: '本季新番',
    score: 8.7,
    episodes: '全 13 话 · 更新至 07',
    air: '每周日 20:00 更新',
    desc: '在小镇修理铺长大的少女，用零件拼出了一台只有半颗心的旧式机器人。为了让它在春天结束前“记住花开的样子”，两人开始了一段笨拙又温柔的旅程。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20illustration%20of%20a%20young%20mechanic%20girl%20with%20goggles%20beside%20a%20small%20brass%20robot%20in%20a%20blooming%20spring%20garden%2C%20warm%20coral%20and%20gold%20palette%2C%20soft%20cinematic%20light%2C%20stylized%20digital%20painting%2C%20cheerful%20mood%2C%20no%20text&width=600&height=800&seq=yaojing-cover-mecha-02&orientation=portrait',
  },
  {
    id: 'fog-detective',
    title: '雾之都侦探社',
    tagline: '雾散之前，真相只有七分钟',
    genres: ['悬疑', '奇幻'],
    tags: ['推理', '复古', '单元剧'],
    season: '本季新番',
    score: 8.9,
    episodes: '全 12 话 · 更新至 06',
    air: '每周五 23:00 更新',
    desc: '在被浓雾常年笼罩的旧城里，一间接手“无法立案事件”的小小侦探社悄然营业。每一桩委托背后都藏着被雾藏起的一段记忆，而社长本人似乎也与那场大雾脱不了干系。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20illustration%20of%20a%20mysterious%20detective%20standing%20in%20a%20foggy%20Victorian%20city%20street%20at%20night%20with%20glowing%20street%20lamps%2C%20deep%20teal%20and%20muted%20amber%20tones%2C%20moody%20atmospheric%20lighting%2C%20stylized%20digital%20painting%2C%20no%20text&width=600&height=800&seq=yaojing-cover-fog-03&orientation=portrait',
  },
  {
    id: 'summer-echo',
    title: '夏日回声日记',
    tagline: '把整个夏天，写成一本日记',
    genres: ['日常', '校园'],
    tags: ['青春', '治愈', '海边'],
    season: '往季补番',
    score: 8.4,
    episodes: '全 12 话 · 已完结',
    air: '已完结 · 可整季补番',
    desc: '搬到海边小镇的转学生，在旧书店里捡到一本写了一半的夏日日记。为了补完它，她开始记录这个小渔村的蝉鸣、汽水、烟花与告别。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20illustration%20of%20a%20seaside%20small%20town%20in%20summer%20with%20sunflower%20fields%20and%20a%20distant%20blue%20sea%20under%20a%20bright%20warm%20sky%2C%20nostalgic%20golden%20hour%20lighting%2C%20stylized%20digital%20painting%2C%20joyful%20summer%20mood%2C%20no%20text&width=600&height=800&seq=yaojing-cover-summer-04&orientation=portrait',
  },
  {
    id: 'azure-canteen',
    title: '苍蓝食堂的午后',
    tagline: '一碗热汤，治愈整条街',
    genres: ['治愈', '日常'],
    tags: ['美食', '温馨', '单元剧'],
    season: '往季补番',
    score: 8.6,
    episodes: '全 24 话 · 已完结',
    air: '已完结 · 两季合集',
    desc: '开在老街尽头的小食堂，每天只在午后营业三小时。老板娘不做招牌菜，只做客人这一刻最想吃到的东西，于是每一集都有一个人被悄悄治愈。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20illustration%20of%20a%20cozy%20little%20cafeteria%20interior%20with%20wooden%20tables%20and%20warm%20hanging%20lamps%2C%20steam%20rising%20from%20a%20bowl%20of%20ramen%2C%20warm%20amber%20palette%2C%20comforting%20atmosphere%2C%20stylized%20digital%20painting%2C%20no%20text&width=600&height=800&seq=yaojing-cover-canteen-05&orientation=portrait',
  },
  {
    id: 'fairy-garden',
    title: '妖精庭院物语',
    tagline: '在花瓣合拢之前，别眨眼',
    genres: ['奇幻', '治愈'],
    tags: ['妖精', '童话', '唯美'],
    season: '本季新番',
    score: 9.0,
    episodes: '全 12 话 · 更新至 05',
    air: '每周六 19:30 更新',
    desc: '少女误入一座只在黄昏显形的庭院，那里住着会替人保管心愿的花之妖精。想取回心愿，就得先帮别的妖精完成一件“无用的好事”。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20illustration%20of%20a%20mystical%20garden%20filled%20with%20glowing%20flower%20spirits%20and%20a%20small%20fairy%20with%20translucent%20wings%20flying%20among%20giant%20blossoms%2C%20teal%20and%20soft%20green%20palette%20with%20warm%20highlights%2C%20whimsical%20stylized%20digital%20painting%2C%20no%20text&width=600&height=800&seq=yaojing-cover-fairy-06&orientation=portrait',
  },
  {
    id: 'dusk-train',
    title: '黄昏列车终点站',
    tagline: '这班车，只开往你不敢回的地方',
    genres: ['悬疑', '日常'],
    tags: ['旅途', '回忆', '慢节奏'],
    season: '深夜档',
    score: 8.8,
    episodes: '全 10 话 · 更新至 09',
    air: '每周三 24:10 更新',
    desc: '一列没有时刻表的旧式列车，只在黄昏时分停靠无名小站。乘客各带着一件不愿放下的往事，而终点站的名字，随最后一位乘客下车而改变。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20illustration%20of%20an%20old%20train%20arriving%20at%20a%20small%20countryside%20station%20during%20a%20warm%20sunset%2C%20long%20shadows%20on%20the%20platform%2C%20coral%20and%20amber%20palette%2C%20nostalgic%20melancholic%20mood%2C%20stylized%20digital%20painting%2C%20no%20text&width=600&height=800&seq=yaojing-cover-dusk-07&orientation=portrait',
  },
  {
    id: 'phantom-library',
    title: '幻夜书房奇谭',
    tagline: '每翻一页，就走进一个夜晚',
    genres: ['奇幻', '悬疑'],
    tags: ['书籍', '异世界', '氛围感'],
    season: '深夜档',
    score: 8.5,
    episodes: '全 12 话 · 更新至 04',
    air: '每周二 24:00 更新',
    desc: '深夜书店的老板会把客人“送进”书里。想离开，就得替那个故事写下一个结局；可越写到后面，越分不清书里书外哪一个才是真实的自己。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20illustration%20of%20a%20magical%20old%20library%20at%20night%20with%20floating%20glowing%20books%20and%20candle%20light%2C%20deep%20teal%20and%20warm%20gold%20palette%2C%20mysterious%20cozy%20atmosphere%2C%20stylized%20digital%20painting%2C%20no%20text&width=600&height=800&seq=yaojing-cover-library-08&orientation=portrait',
  },
  {
    id: 'cat-god',
    title: '猫神大人的委托',
    tagline: '许愿可以，但要交出一样东西',
    genres: ['奇幻', '冒险'],
    tags: ['妖怪', '轻松', '人和妖'],
    season: '往季补番',
    score: 8.3,
    episodes: '全 13 话 · 已完结',
    air: '已完结 · 有第二季',
    desc: '神社后山住着一只自称猫神的巨大白猫。它答应帮人实现愿望，但每次都要求对方交出“直到现在还舍不得的东西”，于是小镇上开始流传一些温暖的怪谈。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20poster%20illustration%20of%20a%20giant%20friendly%20cat%20spirit%20sitting%20on%20a%20torii%20gate%20surrounded%20by%20glowing%20paper%20lanterns%20at%20night%2C%20warm%20coral%20and%20amber%20palette%2C%20playful%20magical%20mood%2C%20stylized%20digital%20painting%2C%20no%20text&width=600&height=800&seq=yaojing-cover-cat-09&orientation=portrait',
  },
];